import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import CustomButton from '../../components/button/button';
import { availableLanguages } from '../../components/data/languageData';
import { useNavigate } from 'react-router-dom';
import TranslatedDocFileViewer from '../../components/viewers/docs-viewer';
import { useLocation } from 'react-router-dom';
import SettingsIcon from '../../assets/icons/settingsIcon';
import TranslationSettings from '../../components/translation/translationSettings';
import { domainName } from '../../components/data/domainName';
import { useDispatch } from 'react-redux';
import { getSignedUrlAction, glossaryDropDownAction, translateDocAction, translateFileAction, translateHtmlFileAction, translateMorePagesAction, viewDocAction } from '../../redux/actions/translationAction';
import errorToast from '../../components/toasts/errorToast';
import TOSModal from '../../components/modals/confirmation/tosModal';
import ErrorModal from '../../components/modals/confirmation/errorModal';
import { useAuth } from '../../context/AuthContext';



export const TranslationPage = () => {

    const { isAdmin, isTeamLead } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const selectedDocument = location.state?.documentData || null;

    const [isLoading, setIsLoading] = useState(false);
    const [isLanguageSelectorOpen, setIsLanguageSelectorOpen] = useState(true);
    const [isTranslationSectionVisible, setIsTranslationSectionVisible] = useState(false);
    const [isGlossariesSelectorOpen, setIsGlossariesSelectorOpen] = useState(false);

    const [translatedData, setTranslatedData] = useState([])
    const [sourceFileUrl, setSourceFileUrl] = useState(null);
    const [targetFileUrl, setTargetFileUrl] = useState(null);
    const [selectedTarget, setSelectedTarget] = useState(null);
    const [targetLanguage, setTargetLanguage] = useState(selectedDocument?.document?.assignedTeam?.target_lang || []);
    const [sourceLanguage, setSourceLanguage] = useState(selectedDocument?.document?.source_lang || null);
    const [glossary, setGlossary] = useState('');
    const [domain, setDomain] = useState('');
    const [glossaryList, setGlossaryList] = useState([]);
    const [showPrompt, setShowPrompt] = useState(selectedDocument?.document?.no_of_pages > 20 ? true : false);
    const [showError, setShowError] = useState(selectedDocument?.document?.name?.endsWith('.pdf') && selectedDocument?.document?.no_of_pages > 300 ? true : false);
    const [search, setSearch] = useState('');
    const [selections, setSelections] = useState([]);
    const [needConfidenceScore, setNeedConfidenceScore] = useState(false)

    const [currentIndex, setCurrentIndex] = useState(0);
    const visibleCount = 4;
    const visibleData = translatedData.slice(currentIndex, currentIndex + visibleCount);

    const handleNext = () => {
        if (currentIndex + visibleCount < translatedData.length) {
            setCurrentIndex(currentIndex + 4);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 4);
        }
    };


    useEffect(() => {
        dispatch(getSignedUrlAction({ fileUrl: selectedDocument?.document?.file_url }, (data) => { setSourceFileUrl(data?.data?.data) }, onError));
    }, [selectedDocument])

    useEffect(() => {
        dispatch(glossaryDropDownAction({ targetLanguages: targetLanguage, domain }, onGlossarySuccess, onError));
    }, [targetLanguage, domain]);


    const onGlossarySuccess = (data) => {
        setGlossaryList(data?.data?.data);
    }

    const onError = (data) => {
        setIsLoading(false);
        errorToast(data?.data?.message)
    }

    const handleButtonClick = (data) => {
        setSelectedTarget(data);
        setIsLoading(true);
        dispatch(getSignedUrlAction({ fileUrl: data?.is_glossary ? data?.glossaryFileUrl : data?.translatedDocumentUrl }, (data) => { setTargetFileUrl(data?.data?.data); setIsLoading(false) }, onError))
    };


    const handleLanguageSelection = (event) => {
        const selectedValue = event.target.value;
        setTargetLanguage((prevSelectedLanguages) =>
            prevSelectedLanguages.includes(selectedValue)
                ? prevSelectedLanguages.filter(language => language !== selectedValue)
                : [...prevSelectedLanguages, selectedValue]
        );
    };

    const handleToggleLanguageSelector = () => {
        setIsLanguageSelectorOpen(true);
        setIsGlossariesSelectorOpen(false)
    };

    const handleToggleGlossaries = () => {
        setIsGlossariesSelectorOpen(true);
        setIsLanguageSelectorOpen(false);
    };

    const handleTranslate = () => {
        setIsLanguageSelectorOpen(false);
        setIsTranslationSectionVisible(true);
        setIsLoading(true)

        const dispatchValues = {
            inputUri: selectedDocument?.document?.gs_url,
            file_url: selectedDocument?.document?.file_url,
            file_name: selectedDocument?.document?.name,
            sourceLanguage: sourceLanguage,
            targetLanguage: targetLanguage,
            num_of_pages: selectedDocument?.document?.no_of_pages,
            document_id: selectedDocument?.document?.id,
            glossary_id: glossary,
            mt_provide_confidence_scores: needConfidenceScore
        }

        console.log(dispatchValues, "dispatching values");
        // if (selectedDocument?.document?.name?.endsWith('.html')) {
        //     dispatch(translateHtmlFileAction(dispatchValues, onTranslationSuccess, onError))
        // } else {
        // if (selectedDocument?.document?.name?.endsWith('.pdf')) {
        dispatch(translateFileAction(dispatchValues, onTranslationSuccess, onError))
        // } else {
        //     if (parseFloat(selectedDocument?.document?.no_of_pages) > 20) {
        //         dispatch(translateMorePagesAction(dispatchValues, onTranslationSuccess, onError));
        //     } else {
        //         dispatch(translateDocAction(dispatchValues, onTranslationSuccess, onError))
        //     }
        // }
        // }

    };

    const onTranslationSuccess = (data) => {
        setTranslatedData(data.data.data);
        const firstIndexData = data.data.data[0];
        setSelectedTarget(firstIndexData);
        setIsLoading(true);
        dispatch(getSignedUrlAction({ fileUrl: firstIndexData?.is_glossary ? firstIndexData?.glossaryFileUrl : firstIndexData?.translatedDocumentUrl }, (data) => { setTargetFileUrl(data?.data?.data); setIsLoading(false) }, onError))
    }

    const handleCancel = () => {
        navigate('/new-translation')
    }

    const handleToggle = () => {
        setNeedConfidenceScore(!needConfidenceScore)
    };

    if (!isAdmin || isTeamLead) {
        return (
            <div className="w-100 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
                <i className="bi bi-shield-lock fs_40 text-danger mb-3"></i>
                <h5 className="fw_600">Access Denied</h5>
                <p className="text-muted fs_14">This page is only accessible to company administrators and team leads.</p>
            </div>
        );
    }

    return (
        <div className='min-vh-100 d-flex flex-column' style={{ backgroundColor: '#E9EEF7' }}>
            <div className="w-100 d-flex align-items-center header border-bottom position-sticky top-0 bg-white py-2">
                <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1"> Translation</h2>
            </div>
            <div className='d-block d-md-flex gap-3'>
                <div style={{ backgroundColor: '#FFFFFF', width: '100%', height: "90vh", }} className='px-3 mt-2 mx-2 rounded-4 '>
                    <div style={{ backgroundColor: '#fff', height: "8%" }} className='ps-4 pt-3'>
                        <CustomButton
                            disabled={true}
                            variant='primary'
                            className='d-flex align-items-center cursor_pointer fs_12'
                            style={{ height: '30px' }}
                        >
                            {availableLanguages.find(lang => lang?.value === sourceLanguage)?.label}
                        </CustomButton>
                    </div>
                    <div className='pt-2' style={{ height: "90%", }} >
                        {selectedDocument?.document?.name?.endsWith('.pdf') || selectedDocument?.document?.name?.endsWith('.html') ?
                            <iframe title="File Preview" src={sourceFileUrl} className='w-100 h-100' /> :
                            <TranslatedDocFileViewer fileUrl={sourceFileUrl} className='w-100 h-100' />
                        }

                    </div>
                </div>

                <div style={{ width: '100%', height: "90vh", backgroundColor: '#FFFFFF' }} className='px-3 mx-2 mt-2 rounded-4 overflow-auto'>
                    {!isTranslationSectionVisible ? (
                        <>
                            <div style={{ height: "7%" }} className='d-flex justify-content-lg-between justify-content-md-between gap-2 ps-4 pe-4 pt-3'>
                                <CustomButton
                                    variant='primary'
                                    className='d-flex align-items-center  fs_12'
                                    style={{ height: '30px' }}
                                    onClick={handleToggleLanguageSelector}
                                >
                                    <span className='fs_sm_12 fs_md_12 fs_12'>Select Languages</span>
                                </CustomButton>
                                <div className='d-flex gap-3'>
                                    <CustomButton
                                        variant='primary'
                                        className='d-flex align-items-center  fs_12'
                                        style={{ height: '30px' }}
                                        onClick={handleToggleGlossaries}
                                    >
                                        <SettingsIcon width={15} height={20} />
                                    </CustomButton>
                                    <CustomButton
                                        variant='primary'
                                        className='d-flex align-items-center fs_12 '
                                        style={{ height: '30px' }}
                                        onClick={handleTranslate}
                                        disabled={targetLanguage.length < 1}
                                    >
                                        Translate
                                    </CustomButton>
                                </div>
                            </div>
                            <hr></hr>

                            {isLanguageSelectorOpen && (
                                <div style={{ height: "87%" }} className='overflow-auto'>
                                    <div className='position-sticky top-0 mx-2'>
                                        <input type='text' placeholder='Search here' className='input-field w-100' value={search} onChange={(e) => setSearch(e.target.value)} />
                                    </div>
                                    <div className="d-flex flex-wrap text-start">
                                        {availableLanguages.filter(language =>
                                            language.label.toLowerCase().includes(search.toLowerCase())).map((language) => (
                                                <div key={language.value} style={{ width: '33%', padding: '10px' }}   >
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            value={language.value}
                                                            checked={targetLanguage.includes(language.value)}
                                                            onChange={handleLanguageSelection}
                                                            style={{ marginRight: '10px' }}
                                                            disabled={language.value === sourceLanguage}
                                                        />
                                                        {language.label}
                                                    </label>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            )}

                            {isGlossariesSelectorOpen && (
                                <TranslationSettings
                                    domain={domainName}
                                    selectedDomain={domain}
                                    setDomain={setDomain}
                                    glossaries={glossaryList}
                                    selectedGlossary={glossary}
                                    setGlossary={setGlossary}
                                    selectedLanguages={targetLanguage}
                                    selections={selections}
                                    setSelections={setSelections}
                                    source={sourceLanguage}
                                    handleToggle={handleToggle}
                                    checked={needConfidenceScore}
                                />
                            )}
                        </>
                    ) : (
                        <>
                            {isLoading ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                                    <Spinner animation="border" variant="primary" />
                                </div>
                            ) : (
                                <>
                                    <div style={{ backgroundColor: '#fff', height: "8%" }} className=' d-flex flex-wrap  justify-content-between'>

                                        <div className="d-flex align-items-center">
                                            {/* Left arrow */}
                                            {currentIndex > 0 && (
                                                <button onClick={handlePrev} className="btn btn-outline-secondary me-2">
                                                    &#8592; {/* Left arrow icon */}
                                                </button>
                                            )}

                                            {/* Visible buttons */}
                                            <div className="d-flex gap-2">
                                                {visibleData.map((data, index) => (
                                                    <CustomButton
                                                        key={index}
                                                        variant={
                                                            selectedTarget?.translatedLanguage === data?.translatedLanguage
                                                                ? 'success'
                                                                : 'secondary'
                                                        }
                                                        className="d-flex align-items-center fs_12"
                                                        style={{ height: '30px' }}
                                                        onClick={() => handleButtonClick(data)}
                                                    >
                                                        {availableLanguages.find(lang => lang?.value === data.translatedLanguage)?.label}
                                                    </CustomButton>
                                                ))}
                                            </div>

                                            {/* Right arrow */}
                                            {currentIndex + visibleCount < translatedData.length && (
                                                <button onClick={handleNext} className="btn btn-outline-secondary ms-2">
                                                    &#8594; {/* Right arrow icon */}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div style={{ height: "90%", }} className='pt-2'>
                                        {selectedDocument?.document?.name?.endsWith('.pdf') || selectedDocument?.document?.name?.endsWith('.html') ?
                                            <iframe title="File Preview" src={targetFileUrl} className='w-100 h-100' /> :
                                            <TranslatedDocFileViewer fileUrl={targetFileUrl} className='w-100 h-100' />
                                        }
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
            <TOSModal show={showPrompt} handleClose={() => setShowPrompt(false)} handleCancel={handleCancel} />
            <ErrorModal show={showError} handleClose={() => setShowError(false)} handleCancel={handleCancel} errorDescription={'The uploaded PDF exceeds the maximum allowed limit of 300 pages per file. Please upload a document with 300 pages or fewer to proceed with the translation.'} />
        </div >
    )
}